import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {ColorPicker} from 'primereact/colorpicker';
import {InputSwitch} from "primereact/inputswitch";
import {Dropdown} from "primereact/dropdown";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dialog} from "primereact/dialog";
import axios from "axios";

const ProjectstatusFormComponent = (props) => {
  const [formData, setFormData] = useState({
    network: localStorage.getItem("networkId"),
  });
  const [loading, setLoading] = useState(false);
  const [projectItemStatuses, setProjectItemStatuses] = useState([]);
  const [selectedProjectItemStatus, setSelectedProjectItemStatus] = useState(null);
  const [projectStatusRules, setProjectStatusRules] = useState([]);
  const [ruleDialog, setRuleDialog] = useState(false);
  const validate = (data) => {
    let errors = {};
    // if (!data.name) {
    //   errors.name = 'Az megnevezés nem lehet üres';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    setFormData({
      ...formData,
      data
    });
    if (props && props.initialValues) {
      axios({
        method: 'put',
        url: process.env.REACT_APP_API_HOST + "/api/v2/project-status/" + formData.id,
        data: data,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          window.App.toastShow('success', 'Sikeres módosítás!');
          window.App.setState({
            rerenderProjectstatusList: true,
            sidebarProjectstatusUpdate: false
          })
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    } else {
      axios({
        method: 'post',
        url: process.env.REACT_APP_API_HOST + "/api/v2/project-status",
        data: data,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({
            rerenderProjectstatusList: true,
            sidebarProjectstatusCreate: false
          })
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  useEffect(() => {
    setLoading(true)
    if (props && props.initialValues) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_HOST + "/api/v2/project-status/" + props.initialValues.id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          setFormData(response.data.data)
          setProjectStatusRules(response.data.data.rules)
          setLoading(false)
        })
        .catch(error => {
          setLoading(false)
        })
    }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/project-item-status",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setProjectItemStatuses(response.data.data.items)
      })
      .catch(error => {

      })
  }, [])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit}) => (
      <form onSubmit={handleSubmit} className="">
        <Panel headerTemplate={
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-list"}></i> Alapadatok
              </h3>
            </div>
          </div>
        } className={""}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>Megnevezés</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="color" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="color"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>Szín</label>
                  <span className="p-inputgroup">
                      <InputText id="color" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     color: '#' + e.target.value.replace('#', '')
                                   })
                                 }}
                                 value={formData.color}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                 style={{width: '80%'}}
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label htmlFor="color">&nbsp;</label>
                <span className="">
                      <ColorPicker value={formData.color}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       color: '#' + e.target.value
                                     })
                                   }}

                      />
                    </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="active"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>Aktív</label>
                  <span className="p-d-block">
                        <InputSwitch
                          className={"p-mt-1"}
                          checked={formData.active}
                          value={formData.active}
                          onChange={e => setFormData({...formData, active: e.target.value})}/>
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
              <Button type="submit" label="Mentés" icon={"pi pi-check"} loading={loading}
                      className="p-button-success"/>
            </div>
          </div>
        </Panel>
        {formData.id &&
          <Panel className={"p-mt-3"} headerTemplate={
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <h3>
                  <i className={"pi pi-list"}></i> Szabályok
                </h3>
              </div>
            </div>
          }>
            <DataTable size={localStorage.getItem('scale')}
                       emptyMessage="Nincs találat."
                       value={projectStatusRules} loading={loading}
                       autoLayout={true}
                       filterDisplay="row"
                       responsiveLayout="scroll"
                       stripedRows
            >
              <Column field="project_item_status.name" header="Projekt tétel státusz"
                      body={(rowData) => {
                        return(
                          <span>{rowData?.project_item_status?.name}</span>
                        )
                      }}
              ></Column>
              <Column body={() => {
                return (
                  <i className={"pi pi-arrow-right"}></i>
                )
              }}/>
              <Column header="Projekt státusz" body={() =>{
                return (
                  <span>{formData.name}</span>
                )
              }}></Column>
            </DataTable>
            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>

              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                <Button type="button" label="Új szabály" icon={"pi pi-plus"} loading={loading}
                        onClick={() => {
                          setRuleDialog(true)
                        }}
                        className="p-button-success"/>
                <Dialog visible={ruleDialog}
                        style={{width: '750px'}}
                        header="Új szabály hozzáadása"
                        modal
                        onHide={() => {
                          setRuleDialog(false)
                        }}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-12"}>
                      <div className="p-field p-fluid">
                        <label htmlFor="project_item_status">Projekt tétel státusz</label>
                        <span className="p-d-block">
                        <Dropdown options={projectItemStatuses}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"project_item_status"}
                                  emptyMessage={"Még nincs státusz..."}
                                  onChange={(e) => {
                                    setSelectedProjectItemStatus(e.value)
                                  }}
                                  value={selectedProjectItemStatus}
                        />
                      </span>
                      </div>
                    </div>
                  </div>
                  <div className={"p-grid p-mt-1"}>
                    <div className={"p-col-12 p-lg-6 p-xl-6"}>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                      <Button type="button" label="Mentés" icon={"pi pi-save"} loading={loading}
                              onClick={() => {
                                setLoading(true)
                                axios({
                                  method: 'post',
                                  data: {
                                    project_item_status: selectedProjectItemStatus,
                                    project_status: formData.id
                                  },
                                  url: process.env.REACT_APP_API_HOST + "/api/v2/project-status-rule",
                                  params: {},
                                  headers: {
                                    'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                    'App-Network': localStorage.getItem("networkId")
                                  }
                                })
                                  .then(response => {
                                    window.App.toastShow('success', 'Sikeres mentés!');
                                    setRuleDialog(false)
                                    axios({
                                      method: 'get',
                                      url: process.env.REACT_APP_API_HOST + "/api/v2/project-status/" + props.initialValues.id,
                                      params: {},
                                      headers: {
                                        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                        'App-Network': localStorage.getItem("networkId")
                                      }
                                    })
                                      .then(response => {
                                        setFormData(response.data.data)
                                        setProjectStatusRules(response.data.data.rules)
                                        setLoading(false)
                                      })
                                      .catch(error => {
                                        setLoading(false)
                                      })
                                  })
                                  .catch(error => {
                                    window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                                    setLoading(false)
                                  })
                              }}
                              className="p-button-success"/>
                    </div>
                  </div>
                </Dialog>
              </div>
            </div>
          </Panel>
        }
      </form>
    )}/>
  )
}
export default withTranslation('common')(ProjectstatusFormComponent);
